/**
 * Cockpit Sécurité Direction - Lafarge Ciments France
 * Point d'entrée React : routage, authentification (Emergent Google OAuth) et
 * filtres globaux.
 */
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { FilterProvider } from "@/contexts/FilterContext";
import { Toaster } from "@/components/ui/toaster";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import FindingsPage from "@/pages/FindingsPage";
import ActionsPage from "@/pages/ActionsPage";
import CCVPage from "@/pages/CCVPage";
import PCEDPage from "@/pages/PCEDPage";
import AccidentsPage from "@/pages/AccidentsPage";
import IndicateursPage from "@/pages/IndicateursPage";
import ClassementsPage from "@/pages/ClassementsPage";
import ScoreBogPage from "@/pages/ScoreBogPage";

function AppRoutes() {
  const location = useLocation();

  // Détection du retour OAuth Google (session_id dans le fragment d'URL) :
  // doit être traité en priorité, avant toute vérification de session existante.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <FilterProvider>
              <DashboardLayout />
            </FilterProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/findings" element={<FindingsPage />} />
        <Route path="/actions" element={<ActionsPage />} />
        <Route path="/ccv" element={<CCVPage />} />
        <Route path="/pced" element={<PCEDPage />} />
        <Route path="/accidents" element={<AccidentsPage />} />
        <Route path="/indicateurs" element={<IndicateursPage />} />
        <Route path="/classements" element={<ClassementsPage />} />
        <Route path="/score-bog" element={<ScoreBogPage />} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
